<template>
  <div>
    <v-toolbar
      v-if="showAddBtn && getModel"
      flat
      color="white"
      class="mx-0 px-0"
    >
      <v-spacer />
      <v-btn
        color="success"
        rounded
        @click="enableBlackListForm"
      >
        <v-icon>fa-plus</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card>
      <WBDBlackListFilter
        :hide-office="hideOffice"
        :hide-level="hideLevel"
        :hide-organization="hideOrganization"
        :hide-user="hideUser"
        :black-list-filter-set="blackListFilterSet"
      />
      <v-card-actions>
        <!--        <v-btn-->
        <!--          v-if="!showAddBtn && blackListFilterSet.user"-->
        <!--          color="error"-->
        <!--          dark-->
        <!--          class="mb-2 mx-auto"-->
        <!--          @click="enableBlackListForm"-->
        <!--        >-->
        <!--          Блокировать-->
        <!--        </v-btn>-->
        <v-spacer />
        <v-btn
          v-if="!showAddBtn && getActiveFilterNumber > 0"
          class="mr-1"
          text
          color="warning"
          @click="resetFilterSet"
        >
          {{ `Очистить` }}
        </v-btn>
        <v-btn
          color="success"
          dark
          class="mb-2"
          @click="requestList(1, options.itemsPerPage)"
        >
          Применить
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card-actions v-if="!loading">
      <v-spacer />
      <v-btn
        text
        color="warning"
      >
        <span> {{ searchResultLabel }} </span>
      </v-btn>
    </v-card-actions>
    <v-data-table
      fixed-header
      :height="tableHeight"
      :headers="headers"
      :items="modelList"
      :options.sync="options"
      :loading="loading"
      :server-items-length="paginatorTotal"
      :footer-props="footerProps"
      class="elevation-1"
    >
      <template v-slot:item="{ item, isSelected, select }">
        <tr :class="getRowClass(item)">
          <td>{{ item.dateString }}</td>
          <td>{{ item.expiredAtString }}</td>
          <td>{{ item.user.fullName }}</td>
          <td>{{ item.levelRu }}</td>
          <td>{{ item.office ? item.office.title : '' }}</td>
          <td>{{ item.organization ? item.organization.title : '' }}</td>
          <td>{{ item.vacancy ? item.vacancy.title: '' }}</td>
          <td>{{ item.reason }}</td>
          <td>{{ item.description }}</td>
          <td>
            <v-card-actions>
              <v-btn
                text
                outlined
                rounded
                small
                color="success"
                @click="onEnableUnBlackListModal(item)"
              >
                <v-icon class="mr-1">
                  mdi-check
                </v-icon>
                Разблокировать
              </v-btn>
            </v-card-actions>
          </td>
        </tr>
      </template>
    </v-data-table>
    <BlackListCreateModal
      v-if="blackListFormEnabled"
      :filter-set="blackListCreateModalData"
      :display-self="blackListFormEnabled"
      :save-callback="reload"
      @onUserBlackListed="onUserBlackListed"
      @onCloseBlackListFormModal="onUserBlackListed"
    />
    <UnBlackListModal
      v-if="unBlackListModalEnabled && unBlackListedUser && unBlackListedUser.id"
      :display-self="unBlackListModalEnabled"
      :save-callback="reload"
      :black-list-entry="unBlackListedUser"
      @onCloseUnBlackListModal="onCloseUnBlackListModal"
      @onUnBlackListModalClose="onCloseUnBlackListModal"
    />
  </div>
</template>
<script>

import WBDBlackListFilter from '@/components/common/filter/black-list-filter'
import ListMixin from '@/mixins/list-mixin'
import BlackListMixin from '@/mixins/black-list-mixin'
import BlackListCreateModal from '@/components/common/black-list/create'
import UnBlackListModal from '@/components/common/black-list/unblock'
import {
  BLACK_LIST_LEVEL_ORGANIZATION,
  BLACK_LIST_LEVEL_OFFICE,
} from '@/components/common/filter/black-list-level'
import { pluriaizeRows } from '@/utils/plural-util'

export default {
  name: 'WBDBlackListManager',
  components: {
    WBDBlackListFilter,
    BlackListCreateModal,
    UnBlackListModal,
  },
  mixins: [ListMixin, BlackListMixin],
  props: {
    showAddBtn: {
      type: Boolean
    },
    office: {
      type: Object
    },
    organization: {
      type: Object
    },
    vacancy: {
      type: Object
    },
    user: {
      type: Object
    },
    level: {
      type: String
    },
  },
  data: () => ({
    blackListCreateModalData: null,
    blackListFormEnabled: false,
    unBlackListModalEnabled: false,
    unBlackListedUser: null,
    hideOffice: false,
    hideLevel: false,
    hideOrganization: false,
    hideUser: false,
    options: {},
    headers: [
      {
        text: 'создан',
        align: 'left',
        sortable: false,
        value: 'dateString',
      },
      {
        text: 'Дата разблокировки',
        align: 'left',
        sortable: false,
        value: 'expiredAtString',
      },
      {
        text: 'Пользователь',
        align: 'left',
        sortable: false,
        value: 'user.fullName',
      },
      {
        text: 'Уровень блокировки',
        align: 'left',
        sortable: false,
        value: 'levelRu',
      },
      {
        text: 'Объект',
        align: 'left',
        sortable: false,
        value: 'office.title',
      },
      {
        text: 'Организация',
        align: 'left',
        sortable: false,
        value: 'organization.title',
      },
      {
        text: 'Вакансия',
        align: 'left',
        sortable: false,
        value: 'vacancy.title',
      },
      {
        text: 'Причина',
        align: 'left',
        sortable: false,
        value: 'reason',
      },
      {
        text: 'Замечание',
        align: 'left',
        sortable: false,
        value: 'description',
      },
      { text: '', value: 'options' },
    ],
  }),
  computed: {
    searchResultLabel () {
      return `Найдено: ${this.paginatorTotal} ${pluriaizeRows(this.paginatorTotal)}`
    },
    getModel () {
      const { office, organization, vacancy } = this.blackListFilterSet
      let model
      if (office) {
        model = office
      }
      if (organization) {
        model = organization
      }
      if (vacancy) {
        model = vacancy
      }

      return model
    },
    getActiveFilterNumber () {
      const params = {
        ...this.blackListFilterSet
      }
      for (const [key, value] of Object.entries(params)) {
        if (!(value || (!value && (value === '0' || value === 0)))) {
          delete params[key]
        }
      }
      return Object.keys(params).length
    },
  },
  watch: {
    options: {
      handler () {
        this.requestList(this.options.page, this.options.itemsPerPage)
      },
      deep: true,
    },
  },
  async  created () {
    // username
    const queryUser = this.$route.query.user
    const queryUsername = this.$route.query.username
    if (queryUser && queryUsername) {
      this.blackListFilterSet.user = { id: this.$route.query.user, fullName: queryUsername }
    }

    this.options = {
      page: 1,
      itemsPerPage: this.footerProps.itemsPerPageOptions[1],
    }
    if (this.office) {
      this.blackListFilterSet.office = this.office
      this.hideOffice = true
      this.hideLevel = true
      this.blackListFilterSet.level = BLACK_LIST_LEVEL_OFFICE
    }
    if (this.organization) {
      this.blackListFilterSet.organization = this.organization
      this.hideOrganization = true
      this.hideLevel = true
      this.blackListFilterSet.level = BLACK_LIST_LEVEL_ORGANIZATION
    }
    // this.$moment.locale('ru')
    // this.$moment.lang('ru')
    // const minDate = this.$moment().add(1, 'days')
    // this.blackListFilterSet.expireAt = minDate.format('YYYY-MM-DD')
  },
  methods: {
    getRowClass: function (item) {
      if (item.isBan) {
        return 'baned-entry'
      }
      if (item.isTemporaryBlocked) {
        return 'blocked-entry'
      }
      return undefined
    },
    onEnableUnBlackListModal (item) {
      this.unBlackListModalEnabled = true
      this.unBlackListedUser = item
    },
    onCloseUnBlackListModal () {
      this.unBlackListModalEnabled = false
      this.unBlackListedUser = null
    },
    onUserBlackListed () {
      this.blackListFormEnabled = false
      this.unBlackListedUser = null
    },
    reload () {
      this.requestList(1, this.options.itemsPerPage)
    },
    enableBlackListForm () {
      const { office, organization, vacancy, user } = this.blackListFilterSet

      this.blackListCreateModalData =
          {
            user,
            'level': this.blackListFilterSet.level,
            'model': {
              'id': null,
            },
          }
      if (office) {
        this.blackListCreateModalData.model = office
      }
      if (organization) {
        this.blackListCreateModalData.model = organization
      }
      if (vacancy) {
        this.blackListCreateModalData.model = vacancy
      }

      if (user || this.blackListCreateModalData.model.id) {
        this.blackListFormEnabled = true
      }
    },
    async resetFilterSet () {
      this.blackListFilterSet = {
        level: null,
        office: null,
        organization: null,
        laborer: null,
        expireAt: null,
      }

      this.$forceUpdate()

      this.eventsBus.$emit(this.eventNames.BLACK_LIST_FILTER_RESET)
    },
  }
}
</script>
<style lang="scss" scoped>
.blocked-entry {
  background-color: #FFECB3 !important;
}
.baned-entry {
  background-color: #ffeaea !important;
}
.style-2 {
  background-color: rgb(114,114,67)
}
</style>
